export type NewsType = {
  src: string;
  subContent?: string;
  content: string;
  title?: string;
  centerImage?: boolean;
  subContentBottom?: boolean;
  isCenterText?: boolean;
  imageCarousel?: string[];
  isCustom?: boolean;
  imgAlt?: string;
  mt?: number;
  mb?: number;
  mtSm?: number;
  mbSm?: number;
  titleCls?: string;
};

export const swyftNews: NewsType[] = [
  {
    src: "images/bord_gáis_news.webp",
    title: "Bord Gáis Energy Acquires Swyft Energy",
    content: "In January 2025, Bord Gáis completed the 100% acquisition of Swyft Energy.",
    subContent: "",
    isCenterText: true
  },

  {
    src: "images/michael_o_leary_news.webp",
    title: "Michael O'Leary Solar PV Installation",
    content: "Swyft Energy installed a 140kWp system at Ryanair CEO Michael O'Leary's Gigginstown farm.",
    subContent: "",
    isCenterText: true
  },

  {
    src: "images/kerry_agribusiness_news.webp",
    title: "Kerry Dairy Ireland Partnership",
    content: "We've partnered with Kerry Dairy Ireland to help farmers reduce electricity costs.",
    subContent: "",
    isCenterText: true
  }
];
